import * as React from "react";
import Box from "@mui/material/Box";
import { IconButton, Tooltip, Modal, Typography } from "@mui/material";
import ModalHeader from "./ModalHeader";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

const ViewModal = ({ row, title, fileKey = "task_img", view, sx, width, height, fontSize }) => {
  const [open, setOpen] = React.useState(false);
  const [scale, setScale] = React.useState(1);
  const fileName = row?.[fileKey];

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleZoomIn = () => setScale(scale + 0.1);
  const handleZoomOut = () => setScale(scale - 0.1);

  const username = row?.name || row?.username || "";

  return view === "profileImage" ? (
    <Box>
      {fileName ? (
        <Box
          sx={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            border: "4px solid #ADD8E6",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            ...sx,
          }}
        >
          <img
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            src={fileName}
            alt="Profile"
          />
        </Box>
      ) : (
        <Box
          sx={{
            width: width ? "90px" : "50px",
            height: height ? "90px" : "50px",
            fontSize: fontSize ? "35px" : "25px",
            borderRadius: "50%",
            border: "4px solid #ADD8E6",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
            fontFamily: "'Roboto', sans-serif",
            bgcolor: "rgb(202, 215, 228)",
            color: "#000000",
          }}
        >
          {username?.charAt(0).toUpperCase()}
        </Box>
      )}
    </Box>
  ) : (
    <>
      <Tooltip title={title}>
        <IconButton onClick={handleOpen} sx={{ color: "rgb(167, 20, 211)" }}>
          <VisibilityIcon />
        </IconButton>
      </Tooltip>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "40%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
          }}
        >
          <ModalHeader title={title} handleClose={handleClose} />
          <Box sx={{ textAlign: "center" }}>
            {fileName && (
              <img
                style={{
                  width: "30%",
                  transform: `scale(${scale})`,
                }}
                src={fileName}
                alt="Preview"
              />
            )}
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: "10px",
              justifyContent: "flex-end",
              marginTop: "10px",
            }}
          >
            <Tooltip title="Zoom Out">
              <IconButton onClick={handleZoomOut}>
                <Typography variant="h5" fontWeight="bold">-</Typography>
              </IconButton>
            </Tooltip>
            <Tooltip title="Zoom In">
              <IconButton onClick={handleZoomIn}>
                <Typography variant="h5" fontWeight="bold">+</Typography>
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ViewModal;
